import { graphql, commitMutation, Environment } from 'react-relay';
import { MutationConfig } from 'relay-runtime';

import {
    userProfileMutation as Mutation,
    EditPersonalProfileInput,
} from './__generated__/userProfileMutation.graphql';

const mutation = graphql`
    mutation userProfileMutation($input: EditPersonalProfileInput!) {
        editPersonalProfile(input: $input) {
            user {
                profile {
                    firstName
                    lastName
                    zipCode
                    currency
                    measurementUnit
                }
            }
        }
    }
`;

type Args = EditPersonalProfileInput & MutationConfig<Mutation>;

export function userProfileMutation(environment: Environment, args: Args): void {
    const {
        firstName,
        lastName,
        userServiceId,
        zipCode,
        currency,
        measurementUnit,
        onCompleted,
        onError,
    } = args;
    commitMutation<Mutation>(environment, {
        mutation,
        variables: {
            input: {
                firstName,
                lastName,
                userServiceId,
                zipCode,
                currency,
                measurementUnit,
            },
        },
        onCompleted,
        onError,
    });
}
